import { useApp } from '@/context/AppContext';
import React, { useState } from 'react';
import { userService } from '@/services/usersService';
import { toast } from '@/components/ui/sonner';
import IsBusyIndicator from '@/components/BusyIndicator';
import { X } from 'lucide-react';

export default function Account() {
    const { userDetails, setUserDetails, saveToLocalStorage } = useApp()
    const [newTag, setNewTag] = useState('');
    const [visibleNewTagInput, setVisibleNewTagInput] = useState(false);
    const [isBusy, setIsBusy] = useState(false);

    const addNewTag = async (value: string) => {
        if (value.trim() === '') return;
        setIsBusy(true);
        try {
            var res = await userService.addUserTags(value.trim());
            userDetails?.Tags.push(res);
            setNewTag('');
            setVisibleNewTagInput(false);
            saveToLocalStorage();
            setIsBusy(false);
        } catch (error) {
            toast.error('שגיאה בהוספת תגית', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
            setIsBusy(false);
        }
    }

    const alertRemoveTag = (tagName: string) => {
        if (window.confirm(`האם אתה בטוח שברצונך להסיר את התגית "${tagName}"?`)) {
            removeTag(tagName);
        }
    };

    const removeTag = async (tagName: string) => {
        if (!userDetails) return;
        try {
            setIsBusy(true);
            await userService.deleteUserTag(getTagIdByTagName(tagName) || '');            
            setUserDetails({ ...userDetails, Tags: userDetails.Tags.filter(tag => tag.tagName !== tagName) });
            setIsBusy(false);
        } catch (error) {
            toast.error('שגיאה בהסרת תגית', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
            setIsBusy(false);
        }
    };

    const getTagIdByTagName = (tagName: string): string | null => {
        if (!userDetails) return null;
        const tag = userDetails.Tags.find(tag => tag.tagName === tagName);
        return tag ? tag.id : null;
    }

    return (
        <div className="p-4 md:p-8 space-y-6 animate-fade-in">
            <header className="mb-6">
                <h1 className="text-2xl md:text-3xl font-bold">חשבון משתמש</h1>
            </header>
            <section className="space-y-4">
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-bold">פרטי משתמש</h2>
                </div>
                <div className="grid gap-4">
                    <div className="bg-card p-6 rounded-2xl border border-border shadow-soft">
                        <p className="mb-2"><strong> שם משתמש: </strong>{userDetails?.name || 'John Doe'} </p>
                        <p className="mb-2"><strong> אימייל: </strong>{userDetails?.email || 'john.doe@example.com'}</p>
                    </div>
                </div>
            </section>
            <header className="mb-6">
                <h2 className="text-lg font-bold">ניהול תגיות</h2>
            </header>
            <section className="space-y-4">
                <div className="grid gap-4">
                    <div className="bg-card p-6 rounded-2xl border border-border shadow-soft">
                        <div className="flex flex-wrap gap-2">
                            {userDetails?.Tags.map((tag, index) => (
                                <button
                                    key={index}
                                    onClick={() => alertRemoveTag(tag.tagName)}
                                    className="px-3 py-1.5 rounded-full text-sm font-medium transition-all bg-primary text-primary-foreground"
                                >
                                    <div className="flex items-center" >
                                        {tag.tagName}
                                        <X className="w-4 h-4 mr-2" />
                                    </div>
                                </button>
                            ))}
                            <button
                                className="px-3 py-1.5 rounded-full text-sm font-medium transition-all bg-secondary text-secondary-foreground"
                                onClick={() => setVisibleNewTagInput(true)}
                                
                            >
                                + הוסף תגית
                            </button>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {visibleNewTagInput && (
                                <div className="mt-4">
                                    <input
                                        type="text"
                                        value={newTag}
                                        onChange={(e) => setNewTag(e.target.value)}
                                        placeholder="הכנס תגית חדשה"
                                        className="px-3 py-1.5 rounded-full text-sm font-medium transition-all bg-secondary text-secondary-foreground"
                                        onSubmit={() => setVisibleNewTagInput(true)}
                                    />
                                    <button
                                        className="px-5 mx-3 py-1.5 rounded-full text-sm font-medium transition-all bg-primary text-primary-foreground"
                                        onClick={() => addNewTag(newTag)}
                                    >
                                        שמירה
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            {isBusy && <IsBusyIndicator />}
        </div>
    );
}